// extracted by mini-css-extract-plugin
module.exports = {"marketContainer":"MarketAvailability_marketContainer__aAKdZ"};